const userRoutes = [
  {
    path: 'tenants',
    component: () => import('@tenants/tenants-root-view'),
    children: [
      {
        path: '',
        name: 'tenants',
        component: () => import('@tenants/tenants-view'),
        meta: {
          title: 'Workspaces',
          requireAuth: true,
          requireTenant: false,
        },
      },
    ],
  },
];

const tenantUserRoutes = [
  {
    path: '',
    name: 'private-home',
    component: () => import('@home/home-view'),
    meta: {
      title: 'Zipteam',
      requireAuth: true,
      requireTenant: true,
    },
  },
  {
    path: 'search',
    component: () => import('@search/search-root-view'),
    redirect: { name: 'search' },
    children: [
      {
        path: '',
        name: 'search',
        component: () => import ('@search/search-view'),
        meta: {
          title: 'Search',
          requireAuth: true,
          requireTenant: true,
        },
      },
    ],
  },
  {
    path: 'settings',
    name: 'settings',
    component: () => import ('@settings/settings-view'),
    redirect: { name: 'settings-profile' },
    children: [
      {
        path: 'profile',
        name: 'settings-profile',
        component: () => import ('@settings/user-profile-view'),
        meta: {
          title: 'Settings',
          requireAuth: true,
          requireTenant: true,
        },
      },
      {
        path: 'locale',
        name: 'settings-locale',
        component: () => import ('@settings/user-locale-view'),
        meta: {
          title: 'Settings',
          requireAuth: true,
          requireTenant: true,
        },
      },
      {
        path: 'admin/workspace',
        name: 'admin-settings-workspace',
        component: () => import ('@settings/admin-workspace-view'),
        meta: {
          title: 'Settings | Admin',
          requireAuth: true,
          requireTenant: true,
          requireAdmin: true,
        },
      },
      {
        path: 'admin/users',
        name: 'admin-settings-users',
        component: () => import ('@settings/admin-users-view'),
        meta: {
          title: 'Settings | Admin',
          requireAuth: true,
          requireTenant: true,
          requireAdmin: true,
        },
      },
    ],
  },
  {
    path: 'skill-explorer',
    component: () => import('@skill-explorer/skill-explorer-root-view'),
    redirect: { name: 'skill-explorer' },
    children: [
      {
        path: '',
        name: 'skill-explorer',
        component: () => import('@skill-explorer/skill-explorer-view'),
        meta: {
          title: 'Skill Explorer',
          requireAuth: true,
          requireTenant: true,
        },
      },
    ],
  },
  {
    path: 'surveys',
    component: () => import('@survey/surveys-root-view'),
    children: [
      {
        path: ':surveyCode',
        component: () => import('@survey/survey-root-view'),
        redirect: { name: 'private-home' },
        children: [
          {
            path: '',
            name: 'survey',
            component: () => import('@survey/survey-view'),
            meta: {
              title: 'Survey',
              requireAdmin: true,
              requireAuth: true,
              requireTenant: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: 'teamup',
    component: () => import('@teamup/teamup-root-view'),
    redirect: { name: 'teamup-select' },
    children: [
      {
        path: 'select',
        name: 'teamup-select',
        component: () => import('@teamup/teamup-select-view'),
        meta: {
          title: 'Team-Up Select',
          requireAuth: true,
          requireTenant: true,
        },
      },
      {
        path: ':code',
        component: () => import('@teamup/teamup-team-root-view'),
        children: [
          {
            path: '',
            name: 'teamup-team',
            component: () => import('@teamup/teamup-team-view'),
            meta: {
              title: 'Team-Up',
              requireAuth: true,
              requireTenant: true,
            },
          },
          {
            path: 'view',
            name: 'teamup-view',
            component: () => import('@teamup/teamup-team-view'),
            meta: {
              title: 'Team-Up View',
              requireAuth: true,
              requireTenant: true,
            },
          },
          {
            path: 'search',
            name: 'teamup-search',
            component: () => import('@teamup/teamup-team-search-view'),
            meta: {
              title: 'Team-Up Search',
              requireAuth: true,
              requireTenant: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: 'users',
    component: () => import('@users/users-root-view'),
    children: [
      {
        path: ':id',
        component: () => import('@users/user-root-view'),
        children: [
          {
            path: '',
            name: 'user',
            component: () => import('@users/user-view'),
            meta: {
              title: 'User',
              requireAuth: true,
              requireTenant: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: 'workspace',
    name: 'workspace',
    component: () => import('@workspace/workspace-view'),
    meta: {
      title: 'Workspace',
      requireAuth: true,
      requireTenant: true,
    },
  },
];

const adminRoutes = [
  {
    path: 'surveys',
    component: () => import('@survey/admin-surveys-root-view'),
    redirect: { name: 'admin-surveys' },
    meta: {
      requireAuth: true,
      requireTenant: true,
      requireAdmin: true,
    },
    children: [
      {
        path: '',
        name: 'admin-surveys',
        component: () => import('@survey/admin-surveys-view'),
        meta: {
          title: 'Surveys',
          requireAuth: true,
          requireTenant: true,
          requireAdmin: true,
        },
      },
      {
        path: ':surveyCode',
        component: () => import('@survey/admin-survey-root-view'),
        children: [
          {
            path: '',
            name: 'admin-survey',
            component: () => import('@survey/admin-survey-view'),
            meta: {
              title: 'Survey Settings',
              requireAuth: true,
              requireTenant: true,
              requireAdmin: true,
            },
          },
        ],
      },
    ],
  },
];

const routes = [
  {
    path: '/',
    component: () => import('@components/root-user-view'),
    children: [
      ...userRoutes,
      {
        path: '',
        component: () => import('@components/root-tenant-user-view'),
        children: [
          ...tenantUserRoutes,
          {
            path: 'admin',
            component: () => import('@components/root-admin-tenant-user-view'),
            children: [
              ...adminRoutes,
            ],
          },
        ],
      },
    ],
  },
];

export default routes;
